'use strict';
const mmWidgets = require('./mm-widgets'),
	cleanNonPrintable = require('@mindmup/js-utils/src/clean-non-printable'),
	removeExtraSpaces = require('@mindmup/js-utils/src/remove-extra-spaces');

// goldPlanDescription = require('../models/gold-plan-description');
require('./show-progress-message');
require('./section-handler-widget');
require('./show-error');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.subscriptionPurchaseWidget = function ({subscriptionModel, subscriptionPlanModel, navigatorShim, listenForExpiredSubscription, taskBuilder, countryListModel}) {
	if (!subscriptionModel || !subscriptionPlanModel || !navigatorShim || !taskBuilder) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		let currentTask;
		const widget = this,
			showError = function (reason) {
				widget.showError(reason);
			},
			startTask = async taskId => {
				if (currentTask) {
					currentTask.cancelIfWaiting();
				}
				currentTask = await taskBuilder.build(taskId);
				return currentTask;
			},
			showAllowedSources = () => {
				const selectedPlan =  subscriptionPlanModel.getSelectedPlan(),
					planSources = selectedPlan && selectedPlan.sources,
					buttons = widget.find('[data-mm-payment]'),
					enableForSources = (sources) => {
						buttons.addClass('hidden');
						sources.forEach((source) => {
							const button = widget.find(`[data-mm-payment~="${source}"]`);
							button.removeClass('hidden');
						});
						trackEvent({
							action: 'popup_opened',
							popup_type: 'purchase_subscription',
						});
						widget.trigger('enableForSources:complete');
					};
				navigatorShim.storeForSession('selectedPlan', JSON.stringify(subscriptionPlanModel.getSelectedPlan()));
				return subscriptionModel.getGoldAccountDetails(false, true)
				.catch(() => false)
				.then(accountInfo => {
					if (!accountInfo || !accountInfo.subscription || accountInfo.active) {
						return;
					}
					navigatorShim.storeForSession('license', JSON.stringify(accountInfo.license));
					if (!planSources) {
						enableForSources(['card']);
						return;
					}
					enableForSources(planSources);
				})
				.catch(showError);
			};
		widget.on('show', showAllowedSources);
		subscriptionModel.addEventListener('accountRegistered', showAllowedSources);
		if (listenForExpiredSubscription) {
			subscriptionModel.addEventListener('expiredSubscription', showAllowedSources);
		}

		subscriptionPlanModel.addEventListener('planSelected', showAllowedSources);
		widget.find('[data-mm-payment~="card"]')
		.click((e) => {

			const button = e.target,
				plan = subscriptionPlanModel.getSelectedPlan(),
				taskId = taskBuilder.newTaskId();
			if (button.getAttribute('data-mm-agree-terms')) {
				subscriptionModel.setAgreedSubscription(true);
			}
			if (!subscriptionModel.hasAgreedSubscription()) {
				widget.showSection('agree-terms-stripe-card');
				return;
			}
			
			trackEvent({
				action: 'subscription_submitted',
				plan_id: plan.id,
				plan_period: plan.period || 'monthly',
				plan_type: plan.type,
				value: plan.price,
				currency: plan.CCY
			});
			
			navigatorShim.open(`/stripe-checkout-launch.html?planId=${plan.id}&taskId=${taskId}`, 'stripe-payments');
			widget.showProgressMessage('Waiting for purchase to be completed...');
			return startTask(taskId)
			.then(task => task.waitFor(taskMetadata => taskMetadata && ['chargeSucceeded', 'chargeFailed'].includes(taskMetadata.status)))
			.then(() => subscriptionModel.reloadAccountDetailsAfterPurchase())
			.then(() => widget.trigger('card:complete'));
		});
		if (countryListModel) {
			widget.find('[data-mm-payment~="enter-billing-address"]').click(async () => {
				widget.showProgressMessage('Loading...');
				try {
					await countryListModel.load();
					widget.showSection('enterBillingDetails');
				} catch (e) {
					widget.showError(e);
				}
			});
		}
		widget.find('[data-mm-payment~="invoice"]')
		.click(async (e) => {
			const button = e.target,
				plan = subscriptionPlanModel.getSelectedPlan(),
				getBillingAddress = () => {
					const billingAddress = {};
					widget.find('[data-mm-role~="billing-address"]').domElements.forEach(domElement => {
						const key = domElement.getAttribute('name'),
							value = removeExtraSpaces(cleanNonPrintable(domElement.value)).trim();
						if (key && value) {
							billingAddress[key] = value;
						}
					});
					return billingAddress;
				};
			if (button.classList.contains('disabled')) {
				return;
			}
			if (button.getAttribute('data-mm-agree-terms')) {
				subscriptionModel.setAgreedSubscription(true);
			}
			if (!subscriptionModel.hasAgreedSubscription()) {
				widget.showSection('agree-terms-invoice');
			} else {
				widget.showProgressMessage('Waiting for purchase to be completed...');
				const taskId = taskBuilder.newTaskId(),
					predicate = taskMetadata => taskMetadata && (taskMetadata.error || taskMetadata.stripe_subscription_id),
					task = await startTask(taskId);

				try {
					const billingAddress = getBillingAddress();
					await task.execAndWaitFor('stripe/subscription_purchase_request', {planId: plan.id, taskId, payByInvoice: true, billingAddress}, predicate);
					if (task.metadata && task.metadata.error) {
						widget.showError(task.metadata.error);
					} else {
						subscriptionModel.reloadAccountDetailsAfterPurchase();
					}
				} catch (err) {
					widget.showError(err);
				}

			}
			widget.trigger('invoice:complete');
		});

		widget.find('[data-mm-payment~="amazon-pay"]')
		.click((e) => {
			const button = e.target,
				taskId = taskBuilder.newTaskId();
			if (button.getAttribute('data-mm-agree-terms')) {
				subscriptionModel.setAgreedSubscription(true);
			}
			if (!subscriptionModel.hasAgreedSubscription()) {
				widget.showSection('agree-terms-amazon-pay');
				return;
			}
			navigatorShim.storeForSession('amazonPayTaskId', taskId);
			navigatorShim.open(`/amazon-pay-launch.html`, 'amazon-pay');
			widget.showProgressMessage('Waiting for purchase to be completed...');
			return startTask(taskId)
			.then(task => task.waitFor(taskMetadata => taskMetadata && ['chargeSucceeded'].includes(taskMetadata.status)))
			.then(() => subscriptionModel.reloadAccountDetailsAfterPurchase())
			.then(() => widget.trigger('amazon-pay:complete'));
		});
		widget.on('hide', () => {
			if (currentTask) {
				currentTask.cancelIfWaiting();
			}
		});
		subscriptionPlanModel.addEventListener('planSelected', plan => {
			navigatorShim.storeForSession('selectedPlan', JSON.stringify(plan));
		});
	});
};
